// extracted by mini-css-extract-plugin
module.exports = {"profilePicture":"header-module--profilePicture--1WJVz","profilePictureLink":"header-module--profilePictureLink--2y_Fq"};